module.exports = __webpack_public_path__ + "static/img/image 58.cce27319.png";